(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var menuToggle = document.getElementById('mobile-menu-toggle');
    var navDrawer = document.getElementById('mobile-nav-drawer');
    var navClose = document.getElementById('mobile-nav-close');
    var navOverlay = document.getElementById('mobile-nav-overlay');

    function openMobileMenu() {
      if (!navDrawer) return;
      navDrawer.classList.add('is-open');
      navDrawer.setAttribute('aria-hidden', 'false');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
      if (!navDrawer) return;
      navDrawer.classList.remove('is-open');
      navDrawer.setAttribute('aria-hidden', 'true');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', openMobileMenu);
    }
    if (navClose) {
      navClose.addEventListener('click', closeMobileMenu);
    }
    if (navOverlay) {
      navOverlay.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navDrawer && navDrawer.classList.contains('is-open')) {
        closeMobileMenu();
      }
    });

    // Close mobile menu if a link is clicked
    var drawerLinks = navDrawer ? navDrawer.querySelectorAll('.mobile-nav-drawer__link') : [];
    drawerLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        closeMobileMenu();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('product-variant-select')) {
        var select = e.target;
        var form = select.closest('form');
        if (!form) return;
        var selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        var isAvailable = selectedOption.getAttribute('data-available') === 'true';
        var isPreorder = selectedOption.getAttribute('data-is-preorder') === 'true';
        var price = selectedOption.getAttribute('data-price');
        var comparePrice = selectedOption.getAttribute('data-compare-at-price');
        var priceRaw = parseInt(selectedOption.getAttribute('data-price-raw'), 10) || 0;
        var comparePriceRaw = parseInt(selectedOption.getAttribute('data-compare-price-raw'), 10) || 0;

        var button = form.querySelector('.product-add-button');
        var buttonText = form.querySelector('.product-add-button-text');
        var preorderProperty = form.querySelector('.product-preorder-property');
        var container = form.closest('.product-page__container');
        var priceContainer = container ? container.querySelector('.product-page__price') : null;

        if (button && buttonText) {
          if (!isAvailable) {
            button.disabled = true;
            buttonText.textContent = 'Sold out';
          } else {
            button.disabled = false;
            if (isPreorder) {
              buttonText.textContent = 'Pre-order';
            } else {
              buttonText.textContent = 'Add to cart';
            }
          }
        }

        if (preorderProperty) {
          preorderProperty.disabled = !isPreorder;
        }

        if (priceContainer && price) {
          if (comparePriceRaw > priceRaw) {
            priceContainer.innerHTML =
              '<span class="product-page__price--sale">' + price + '</span> ' +
              '<span class="product-page__price--compare">' + comparePrice + '</span>';
          } else {
            priceContainer.innerHTML =
              '<span class="product-page__price--regular">' + price + '</span>';
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
